import { Component, inject, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '@services/auth/auth.service';
import { AvatarComponent } from '@shared/atoms/avatar/avatar.component';
import { DividerComponent } from '@shared/atoms/divider/divider.component';

@Component({
  selector: 'app-user-menu',
  imports: [CommonModule, MatIconModule, AvatarComponent, DividerComponent],
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
})
export class UserMenuComponent {
  private readonly _authService = inject(AuthService);

  protected readonly userProfile = this._authService.get_current_user();

  /** Emits when user clicks logout */
  readonly logout = output<void>();

  protected onLogout(): void {
    this.logout.emit();
  }
}
